module.exports = __webpack_public_path__ + "img/icon-wheel.742ba7fe.svg";